export enum UsageRegionTarget {
  TARGET_COUNTRY = 'targetCountry',
  EU_AUTHORITY = 'euAuthority',
}
